"use client"
import PropTypes from 'prop-types';
import { useMemo, useState, useContext, createContext } from 'react';

const FiltersContext = createContext(null);

export const useFilters = () => useContext(FiltersContext);

export const FiltersProvider = ({ children }) => {
    const [filters, setFilters] = useState({});
    const [collection, setCollection] = useState('Featured Products');

    const isEmptyFilters = () => !Object.keys(filters).find(k => filters[k]);


    const filtersContextValue = useMemo(() => ({
        filters,
        setFilters,
        isEmptyFilters,
        collection,
        setCollection
    }), [filters, setFilters, isEmptyFilters, collection. setCollection]);

    return (
        <FiltersContext.Provider value={filtersContextValue}>
            {children}
        </FiltersContext.Provider>
    );
};
